export const PlayerPanel = {};
